export const EMAIL_CONFIGURATION = "EMAIL_CONFIGURATION";
export const LOADING = "LOADING";
